import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';
@Injectable({
	providedIn: 'root'
})
export class GroupiTierService {
	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }

	getTierData(inputJson): Observable<any> {
		return this.http
			.post(`${this.constantsService.baseAPIURL}/gi/tierGrid`, inputJson, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError)
			);
	}

	onTierChangeGetRounds(periodId, tierPosition): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/getRounds/${periodId}/${tierPosition}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)
			);
	}

	signUp(kpiId, userId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/signup/${kpiId}/${userId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(

				catchError(this.handleError)
			);
	}

	usAssign(kpiId, userId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/unAssign/${kpiId}/${userId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError)
			);
	}



	getTiersByPeriodId(periodId: any): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/getTiersByPeriodId/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)
			);
	}

	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}


}